// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainContainer__g2wnj {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  margin: 0;
  overflow: hidden;
}

.mainContainerRow__PeEdc {
  display: grid;
  grid-template-columns: fit-content(80px) auto;
  grid-template-rows: fit-content(36px) minmax(0, 100%);
  grid-template-areas:
    "banner banner"
    "sidenav main";

  & .pluginWrapper__hym6X {
    background-color: #251704;
  }

  & .pluginContainer__JXvCL {
    height: calc(100% - 16px);
    border-radius: 4px;
    background-color: white;
    margin: 8px 8px 8px 0;
  }
}

.pluginWrapper__hym6X {
  grid-area: main;
  height: 100%;
  overflow: hidden;
}

.pluginContainer__JXvCL {
  height: 100%;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.flexFSWrapper__g4w2e {
  flex-grow: 1;
  min-height: 0;
}

.flexFSWrapper__g4w2e>div>div {
  height: calc(100% - 0.5px) !important;
}

/* Mobile styles (under 480px) */
@media only screen and (max-width: 480px) {
  .mainContainerRow__PeEdc {
    & .pluginContainer__JXvCL {
      margin: 0;
      border-radius: 8px 8px 0 0;
    }
  }

  .mainContainerRow__PeEdc {
    display: flex;
    flex: 1;
    flex-direction: column;
  }
}

#glance_cobrowse_btn {
  left: 375px !important;
  right: auto !important;
}

/* 
*  FHA in DMB Maps are Overlay Images
*  Layers in DMB/Programs are Tiles
*  Setting max-width to none, it makes sure the imgs are visible to the user
* */
.leaflet-tile-pane img, .leaflet-overlay-pane img {
  max-width: none;
}
`, "",{"version":3,"sources":["webpack://./src/router/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,qDAAqD;EACrD;;kBAEgB;;EAEhB;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;EACvB;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA,gCAAgC;AAChC;EACE;IACE;MACE,SAAS;MACT,0BAA0B;IAC5B;EACF;;EAEA;IACE,aAAa;IACb,OAAO;IACP,sBAAsB;EACxB;AACF;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;;;GAIG;AACH;EAEE,eAAe;AACjB","sourcesContent":[".mainContainer {\n  display: flex;\n  flex-direction: column;\n  height: 100dvh;\n  margin: 0;\n  overflow: hidden;\n}\n\n.mainContainerRow {\n  display: grid;\n  grid-template-columns: fit-content(80px) auto;\n  grid-template-rows: fit-content(36px) minmax(0, 100%);\n  grid-template-areas:\n    \"banner banner\"\n    \"sidenav main\";\n\n  & .pluginWrapper {\n    background-color: #251704;\n  }\n\n  & .pluginContainer {\n    height: calc(100% - 16px);\n    border-radius: 4px;\n    background-color: white;\n    margin: 8px 8px 8px 0;\n  }\n}\n\n.pluginWrapper {\n  grid-area: main;\n  height: 100%;\n  overflow: hidden;\n}\n\n.pluginContainer {\n  height: 100%;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.flexFSWrapper {\n  flex-grow: 1;\n  min-height: 0;\n}\n\n.flexFSWrapper>div>div {\n  height: calc(100% - 0.5px) !important;\n}\n\n/* Mobile styles (under 480px) */\n@media only screen and (max-width: 480px) {\n  .mainContainerRow {\n    & .pluginContainer {\n      margin: 0;\n      border-radius: 8px 8px 0 0;\n    }\n  }\n\n  .mainContainerRow {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n  }\n}\n\n:global(#glance_cobrowse_btn) {\n  left: 375px !important;\n  right: auto !important;\n}\n\n/* \n*  FHA in DMB Maps are Overlay Images\n*  Layers in DMB/Programs are Tiles\n*  Setting max-width to none, it makes sure the imgs are visible to the user\n* */\n:global .leaflet-tile-pane img,\n:global .leaflet-overlay-pane img {\n  max-width: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `mainContainer__g2wnj`,
	"mainContainerRow": `mainContainerRow__PeEdc`,
	"pluginWrapper": `pluginWrapper__hym6X`,
	"pluginContainer": `pluginContainer__JXvCL`,
	"flexFsWrapper": `flexFSWrapper__g4w2e`
};
module.exports = ___CSS_LOADER_EXPORT___;
